import { useQuery } from '@apollo/client'
import { GET_ADMIN_REPORTS } from 'data/queries'
import { AdminReports } from '../queries/types/AdminReports'

const useAdminReports = () => {
  const { loading, error, data } = useQuery<AdminReports>(GET_ADMIN_REPORTS)

  return {
    loading,
    error,
    data,
  }
}

export { useAdminReports }
